/* unplugin-vue-components disabled */import script from "./editPhone.vue?vue&type=script&setup=true&lang=ts"
export * from "./editPhone.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__